<template src="./WarehouseUpdateOrCreateComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {useAccountStore} from "@/stores/account.js";
import {AppConstant} from "@/supports/app.constant";
import {ref, computed, onMounted, watch} from "vue";
import CommonService from "@/services/common.service.ts";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import {ErrorMessageConstant, ErrorText} from "@/supports/error-message.constant.ts";
import InputTextareaNormal from "@/components/inputs/input-textarea/normal/InputTextareaNormal.vue";
import {useRoute, useRouter} from "vue-router";
import {useWarehouseStore} from "@/stores/warehouse.js";
import {useStore} from "@/stores/store.js";
export default {
  name: 'WarehouseUpdateOrCreateComponent',
  components: {
    InputTextareaNormal,
    ButtonAddComponent,
    IconEye,
    LabelStatus,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome},
  setup() {
    const errors = ref(true)
    const mode = ref('create')
    const warehouse_id = ref(null)
    const labelButtonSetting = ref('Tạo kho hàng')
    const usingWarehouse = ref(null)
    const dataWarehouse = ref({
      warehouse_name: {
        id: 'warehouse_name',
        label: 'Tên kho hàng',
        placeholder: 'Tên kho hàng',
        value: '',
        error: '',
        isError: false,
        required: true
      },
      warehouse_code: {
        id: 'warehouse_code',
        label: 'Mã kho hàng',
        placeholder: 'Mã kho hàng',
        value: '',
        error: '',
        isError: false,
        required: true
      },
      warehouse_phone: {
        id: 'warehouse_phone',
        label: 'Số điện thoại',
        placeholder: 'Số điện thoại',
        value: '',
        error: '',
        isError: false,
        required: true
      },
      warehouse_address: {
        id: 'warehouse_address',
        label: 'Địa chỉ kho hàng',
        placeholder: 'Địa chỉ kho hàng',
        value: '',
        error: '',
        isError: false,
        required: true
      },
    })
    const router = useRouter()
    const route = useRoute()
    const accountStore = useAccountStore()
    const warehouseStore = useWarehouseStore()

    onMounted(() => {
      mode.value = route.params.mode;
      if(mode.value === 'detail') {
        labelButtonSetting.value = 'Cập nhập kho hàng';
        warehouse_id.value =  route.params.id;
        getDataWarehouseDetail();
      }
    });

    async function createOrUpdateWarehouse() {
      for (const item in dataWarehouse.value) {
        validateForm(dataWarehouse.value[item].value, item)
      }
      if(checkSubmitActive.value) {
        const params = {
          m_company_id: accountStore.account.company.id,
          name: dataWarehouse.value.warehouse_name.value,
          code: dataWarehouse.value.warehouse_code.value,
          phone: dataWarehouse.value.warehouse_phone.value,
          address: dataWarehouse.value.warehouse_address.value,
          id: warehouse_id.value,
        }
        let url = AppConstant.URL_API_LOCAL + 'api/warehouse/create-warehouse';
        if(mode.value === 'detail') {
          params.id = warehouse_id.value;
          url = AppConstant.URL_API_LOCAL + 'api/warehouse/update-warehouse';
        }
        const warehouse = await warehouseStore.createOrUpdateWarehouse(url, params);
        await CommonService.showAlertPopup({
          title: warehouse?.message,
          icon: "success",
          showConfirmButton: false,
          timer: 1000,
          width: '800px'
        });

        await router.push('/warehouse')
      }
    }

    watch(() => warehouseStore.warehouse, (newWarehouse) => {
      dataWarehouse.value.warehouse_name.value = newWarehouse.name;
      dataWarehouse.value.warehouse_code.value = newWarehouse.code;
      dataWarehouse.value.warehouse_phone.value = newWarehouse.phone;
      dataWarehouse.value.warehouse_address.value = newWarehouse.address;
    });

    function getDataWarehouseDetail() {
      const params = {
        company_id: accountStore.account.company.id,
        id: warehouse_id.value,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/warehouse/detail';
      warehouseStore.getWarehouseDetail(url, params);
    }
    function onChange(value, name) {
      dataWarehouse.value[name].value = value
    }
    function validateForm(value, name) {
      if(name === 'warehouse_name') {
        dataWarehouse.value.warehouse_name.isError = false;
        dataWarehouse.value.warehouse_name.error = ''
        errors.value = false
        if(!value) {
          dataWarehouse.value.warehouse_name.isError = true;
          dataWarehouse.value.warehouse_name.error = ErrorText.REQUIRED(dataWarehouse.value.warehouse_name.label);
          errors.value = true
        }
        if(!errors.value && value.length > AppConstant.MAX_LENGTH_TEXT) {
          dataWarehouse.value.warehouse_name.isError = true;
          dataWarehouse.value.warehouse_name.error = ErrorText.MAX_LENGTH(dataWarehouse.value.warehouse_name.label, AppConstant.MAX_LENGTH_TEXT);
          errors.value = true
        }
      }
      if(name === 'warehouse_code') {
        dataWarehouse.value.warehouse_code.isError = false;
        dataWarehouse.value.warehouse_code.error = ''
        errors.value = false
        if(!value) {
          dataWarehouse.value.warehouse_code.isError = true;
          dataWarehouse.value.warehouse_code.error = ErrorText.REQUIRED(dataWarehouse.value.warehouse_code.label);
          errors.value = true
        }
        if(!errors.value && value.length > AppConstant.MAX_LENGTH_SKU_CODE) {
          dataWarehouse.value.warehouse_code.isError = true;
          dataWarehouse.value.warehouse_code.error = ErrorText.MAX_LENGTH(dataWarehouse.value.warehouse_code.label, AppConstant.MAX_LENGTH_SKU_CODE);
          errors.value = true
        }
      }
      if(name === 'warehouse_phone') {
        dataWarehouse.value.warehouse_phone.isError = false;
        dataWarehouse.value.warehouse_phone.error = ''
        errors.value = false
        if(!value) {
          dataWarehouse.value.warehouse_phone.isError = true;
          dataWarehouse.value.warehouse_phone.error = ErrorText.REQUIRED(dataWarehouse.value.warehouse_phone.label);
          errors.value = true
        }
        if(!errors.value && ![10, 11].includes(value.length)) {
          dataWarehouse.value.warehouse_phone.isError = true;
          dataWarehouse.value.warehouse_phone.error = ErrorMessageConstant.ERROR_PHONE_LENGTH;
          errors.value = true
        }
      }
      if(name === 'warehouse_address') {
        dataWarehouse.value.warehouse_address.isError = false;
        dataWarehouse.value.warehouse_address.error = ''
        errors.value = false
        if(!value) {
          dataWarehouse.value.warehouse_address.isError = true;
          dataWarehouse.value.warehouse_address.error = ErrorText.REQUIRED(dataWarehouse.value.warehouse_address.label);
          errors.value = true
        }
        if(!errors.value && value.length > AppConstant.MAX_LENGTH_TEXT) {
          dataWarehouse.value.warehouse_address.isError = true;
          dataWarehouse.value.warehouse_address.error = ErrorText.MAX_LENGTH(dataWarehouse.value.warehouse_address.label, AppConstant.MAX_LENGTH_TEXT);
          errors.value = true
        }
      }
    }

    const checkSubmitActive = computed(() => {
      return !errors.value;
    })

    return {
      createOrUpdateWarehouse,
      dataWarehouse,
      mode,
      usingWarehouse,
      labelButtonSetting,
      CommonService,
      errors,
      onChange,
      validateForm,
      checkSubmitActive
    }
  },
}
</script>
<style lang="scss">
.dashboard-page {
  margin-top: 80px;
  margin-left: 80px;
  height: 100%;
  .title-page {
    padding: 15px 30px;
    background-color: #fff;
  }
  .container-fluid {
    padding-top: 30px;
    .card {
      margin-bottom: 30px;
      letter-spacing: .5px;
      box-shadow: 0 9px 20px rgba(46,35,94,.07);
      .card-body {
        padding: 30px;
        border-radius: 15px;
        background-color: #ffffff;
        .btn-invite-partner {
          width: 150px;
          margin-top: 50px;
        }
        .list-partners-component {
          margin-top: 30px;
          .label_priority {
            padding: 5px;
            border: 1px solid #f73164;
            border-radius: 5px;
            max-width: 120px;
            width: 120px;
            display: flex;
            align-content: center;
            justify-content: center;
            color: #ffffff;
          }
          td.action {
            display: flex;
            justify-content: center;
            gap: 20px;
            .item-action {
              width: 20px;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>
